import { API } from "@/lib/api";

const uid = () => (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2));

export function getVisitorId() {
  let v = localStorage.getItem("gk_vid");
  if (!v) { v = uid(); localStorage.setItem("gk_vid", v); }
  return v;
}

export function getSessionId() {
  let s = sessionStorage.getItem("gk_sid");
  if (!s) { s = uid(); sessionStorage.setItem("gk_sid", s); }
  return s;
}

// Fire-and-forget event using keepalive so it survives page unload.
export function track(type, extra = {}) {
  try {
    const body = JSON.stringify({
      type,
      path: window.location.pathname + window.location.search,
      ref: document.referrer || "",
      vid: getVisitorId(),
      sid: getSessionId(),
      title: document.title || "",
      ...extra,
    });
    fetch(`${API}/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
      credentials: "omit",
    }).catch(() => {});
  } catch (_) { /* ignore */ }
}
